var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisbleStapper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2348 4.5119C18.9494 1.08374 12.2835 0.798064 9.23624 1.08374C8.37919 1.55986 6.43655 2.6835 5.52237 3.36913C4.37965 4.22617 2.09425 8.51137 1.52289 10.5111C0.951532 12.5109 1.80857 14.7963 2.66561 16.2247C3.52265 17.6531 7.52216 21.6526 9.23624 22.7954C10.9503 23.9381 15.8069 24.5094 17.2353 24.7951C18.6637 25.0808 21.2348 23.081 22.9489 21.0813C24.3201 19.4815 24.6629 15.082 24.6629 13.0822C24.4725 11.6539 23.5202 7.94006 21.2348 4.5119Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 1.14272
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8075 12.9983C13.3504 12.5412 8.66525 15.4744 6.95117 17.8551C8.09389 19.5691 11.2364 21.2831 12.3791 21.5688C13.5218 21.8545 14.3788 13.5697 13.8075 12.9983Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0927 12.9985C13.7341 12.4607 17.8713 16.8574 19.5204 19.2835C19.1885 20.9891 11.5071 21.7888 12.6643 21.569C12.95 21.5147 14.664 13.8555 14.0927 12.9985Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2358 12.4272C13.6915 12.8857 9.23658 14.7126 6.95106 17.8552C5.23674 16.4267 4.11816 12.8124 3.83597 11.6688C3.55378 10.5252 12.6662 11.8541 13.2358 12.4272Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.093 12.4273C13.5466 12.7726 17.8504 15.7315 19.3779 19.3044C21.1127 19.4027 23.2349 13.2844 22.0921 13.2844C20.2629 13.2844 14.7761 11.9956 14.093 12.4273Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2353 12.1415C12.6982 12.5012 9.65002 7.85909 8.43052 5.19105C9.04337 3.56512 12.3446 3.34392 13.521 3.28543C14.6974 3.22693 13.9067 11.6919 13.2353 12.1415Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6779 12.0369C13.2218 12.4949 18.4693 8.75977 20.5579 6.69981C20.5633 4.96222 12.8473 2.91196 13.9399 3.35211C14.2096 3.46077 14.4047 11.307 13.6779 12.0369Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9499 12.1416C13.5466 12.3902 10.0113 8.52608 8.37907 4.99978C6.89964 6.26184 3.80846 8.14217 3.80846 11.2846C3.80846 11.6 9.52189 10.7131 12.9499 12.1416Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0932 11.8559C15.3577 11.4444 18.6642 7.57064 20.6638 6.99937C22.3847 7.23959 23.4178 13.0383 22.2399 13.0383C20.6638 13.0383 13.3249 12.1059 14.0932 11.8559Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6704 11.6625C14.6704 11.2054 12.9563 10.934 12.9563 12.2339C12.8414 13.3767 14.1561 13.3767 14.3847 13.3767H14.3847C14.956 13.3767 14.6704 12.2339 14.6704 11.6625Z",
    fill: "#F7F7F7",
    stroke: "#4F4F4F",
    strokeWidth: 0.857039
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisbleStapper);
export default __webpack_public_path__ + "static/media/disbleStapper.a1305200e0f05a2cc4f3bf7212d3590a.svg";
export { ForwardRef as ReactComponent };